import { SELECT_MAXIMUM_LIMIT, TICKET_STATUS } from 'src/constants/Constants'

// Remove value Array check in SearchForm for ticket_type_id when enable packing and remove filter in TodoListMobile data
export const INITIAL_JOBS_SEARCH_PARAMS = {
  id: '',
  ticket_type_id: '',
  warehouse_id: '',
  start_date: '',
  batch_id: '',
  proxpert_batch: '',
  client_id: '',
  picking_method_id: '',
  user_name: '',
  ticket_status_id: '',
  order_id: '',
  order_number: '',
  sku: '',
  sort_method: 'desc',
  order_by: 'id',
  limit: 15,
  page: 1,
}

export const INITIAL_PICKING_DETAILS_SEARCH = {
  location_id: '',
  user_id: '',
  user_name: '',
  item_id: '',
  order_number: '',
}

export const INITIAL_SORTATION_DETAILS_SEARCH = {
  location_id: '',
  user_id: '',
  item_id: '',
  order_number: '',
}

export const INITIAL_PACKING_DETAILS_SEARCH = {
  item_id: '',
  order_number: '',
  user_id: '',
  status: '',
}

export const PACKING_LINE_STATUS = {
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  PACKED: 'packed',
}

export const PACKING_LINE_STATUS_LABELS = {
  [PACKING_LINE_STATUS.NOT_STARTED]: 'not-started',
  [PACKING_LINE_STATUS.IN_PROGRESS]: 'in-progress',
  [PACKING_LINE_STATUS.PACKED]: 'packed',
}

export const INITIAL_JOB_SEARCH = {
  sort_method: 'desc',
  order_by: 'id',
  ticket_status_id: [TICKET_STATUS.OPEN, TICKET_STATUS.IN_PROGRESS],
  limit: SELECT_MAXIMUM_LIMIT,
  page: 1,
}

export const INITIAL_JOB_DETAILS = {
  warehouse_id: '',
  picking_method_id: '',
  user_id: '',
  user_ids: [],
}

export const INITIAL_PACKING_SLIP_DETAILS = {
  client_id: '',
  batch_id: '',
  batches: [],
}

export const EMPTY_PROXPERT_BATCH_DETAILS = {
  client_id: '',
  batch_id: '',
  batches: [],
}

export const PROXPERT_SPLIT_BY = {
  ORDERS: 'orders',
  UNITS: 'units',
  ITEMS: 'items',
}

export const PROXPERT_PICK_JOB_SPLIT_BY = {
  ITEM_LOCATION: 'item_location',
  LOCATION_ITEM: 'location_item',
}

export const PICK_JOB_SPLIT_BY_LABELS = {
  [PROXPERT_PICK_JOB_SPLIT_BY.ITEM_LOCATION]: 'item-location',
  [PROXPERT_PICK_JOB_SPLIT_BY.LOCATION_ITEM]: 'location-item',
}

export const BATCH_PICK_DEFAULT_BATCHES_NEEDED = 1

export const SORTATION_REQUIRED_BATCH_DEFAULTS = {
  sortation_required: true,
  separate_forklift_job: true,
  batches_needed: BATCH_PICK_DEFAULT_BATCHES_NEEDED,
  split_by: PROXPERT_SPLIT_BY.ORDERS,
  pick_job_split_by: PROXPERT_PICK_JOB_SPLIT_BY.LOCATION_ITEM,
}

export const INITIAL_PROXPERT_QUICK_BATCH = {
  clients: [],
  client_include: '',
  warehouse_id: '',
  picking_method_id: '',
  date_to: '',
  sortation_required: false,
  separate_forklift_job: false,
  apply_rule: 1,
  batches_needed: '',
  orders_to_process: '',
  split_by: PROXPERT_SPLIT_BY.ORDERS,
  pick_jobs_needed: '',
  pick_job_split_by: PROXPERT_PICK_JOB_SPLIT_BY.LOCATION_ITEM,
  proxpert_batches: [],
  countries: [],
  order_types: [],
  processing_priority: '',
  handling_priority: '',
  units_operator: '<=',
  units_value: '',
  items_operator: '>=',
  items_value: '',
  pickable_type_id: '',
}

export const PROXPERT_QUICK_BATCH_PREVIEW_FIELDS = {
  total_available_orders: '',
  total_criteria_orders: '',
  total_filtered_orders: '',
  orders_not_in_bridge_count: '',
  orders_not_in_bridge: [],
  ineligible_orders_count: '',
  ineligible_orders: [],
  total_selected_orders: '',
  total_units: '',
  total_items: '',
  total_batches: '',
  total_locations: '',
  fifo_from: '',
  fifo_to: '',
  batches_details: [],
  pick_jobs: [],
}

export const QUANTITY_FILTER_OPERATORS = ['=', '>', '>=', '<', '<=']

export const PROXPERT_QUICK_BATCH_FILTER_KEYS = [
  'proxpert_batches',
  'order_types',
  'processing_priority',
  'handling_priority',
  'pickable_type_id',
  'units',
  'items',
  'countries',
]

export const DEFAULT_PROXPERT_QUICK_BATCH_FILTERS = [
  'proxpert_batches',
  'handling_priority',
  'pickable_type_id',
  'units',
]

export const PROXPERT_QUICK_BATCH_FILTER_RESET_VALUES = {
  proxpert_batches: { proxpert_batches: [] },
  countries: { countries: [] },
  order_types: { order_types: [] },
  processing_priority: { processing_priority: '' },
  handling_priority: { handling_priority: '' },
  pickable_type_id: { pickable_type_id: '' },
  units: { units_operator: '<=', units_value: '' },
  items: { items_operator: '>=', items_value: '' },
}

export const API_PATHS = {
  PROXPERT_QUICK_BATCH: 'POST /orders/import/proxpert/quick-batches/create',
}
